import React from 'react';

interface IPodaneZadosti {}

const PodaneZadosti: React.FC<IPodaneZadosti> = () => {
    return <></>;
};

export default PodaneZadosti;
